class FormAutoFillLock {
	constructor() {
		this.els = []
		this._init()
	}
	_init() {
		this.els = document.querySelectorAll('[data-form-auto-fill-lock]');
		this.els.forEach((el) => el.addEventListener('change', (ev) => this.changeHandler(el, ev)))
	}
	changeHandler(el, ev) {
		const forms = el.dataset.formAutoFillLock.split('|')

		if (forms.length !== 2) {
			return
		}

		const formDstName = forms[0].trim()
		const formSrcName = forms[1].trim()

		if (el.checked) {
			this.autoFillAndLock(formDstName, formSrcName)
		} else {
			this.unlock(formDstName)
		}
	}
	autoFillAndLock(formDstName, formSrcName) {
		const formSrcEl = document.querySelector(`[data-form='${formSrcName}']`)
		const formDstEl = document.querySelector(`[data-form='${formDstName}']`)
		if (!formDstEl || !formSrcEl) {
			return
		}
		this.lock(formDstEl, true)

		const formSrcEls = Array.from(formSrcEl.querySelectorAll('[data-field]'))
		formDstEl.querySelectorAll('[data-field]').forEach((el) => {
			const id = el.dataset.field
			const foundEl = formSrcEls.find(e => e.dataset.field == id)
			if (!foundEl) {
				return
			}
			const dstEl = el.querySelector('input, select, textarea')
			const srcEl = foundEl.querySelector('input, select, textarea')

			if (dstEl.nodeName == 'INPUT') {
				dstEl.value = srcEl.value
			} else if (dstEl.nodeName == 'SELECT') {
				dstEl.value = srcEl.value
				dstEl.dispatchEvent(new Event('change'))
			} else if (dstEl.nodeName == 'TEXTAREA') {
				dstEl.value = srcEl.value
			}
		})
	}
	unlock(formDstName) {
		const formEl = document.querySelector(`[data-form='${formDstName}']`)
		if (!formEl) {
			return
		}
		this.lock(formEl, false)
	}
	lock(form, value) {
		form.querySelectorAll('[data-field]')
			.forEach((el) => {
				if (value) {
					el.classList.add('field--desactive')
				} else {
					el.classList.remove('field--desactive')
				}
				el.querySelectorAll('input, select, textarea').forEach(el2 => el2.disabled = value)
			})
	}
}

export default FormAutoFillLock